import React from 'react';
// import { pitchTransform } from './pitchShifter';

export default function useAudioPlayer(
    audioContext,
    url,
    onPlaybackEnd,
    paused
) {
    const [buffer, setBuffer] = React.useState(null);
    const [duration, setDuration] = React.useState(null);
    const [elapsed, setElapsed] = React.useState(null);

    const startedPlayingAt = React.useRef(null);
    const timeoutRef = React.useRef(null);
    const [source, setSource] = React.useState(null);
    const [playing, setPlaying] = React.useState(false);

    // When getting a new URL, decode the audio and place in buffer
    React.useEffect(() => {
        if (!url) return;
        window
            .fetch(url)
            .then(response => response.arrayBuffer())
            .then(
                arrayBuffer =>
                    new Promise((resolve, reject) => {
                        audioContext.decodeAudioData(
                            arrayBuffer,
                            resolve,
                            reject
                        );
                    })
            )
            .then(buffer => {
                setBuffer(buffer);

                // If you want to shift pitch on the pre-recorded audio
                // let pitchShiftPromise = pitchTransform(buffer, 0);
                // pitchShiftPromise.then(newBuffer => {
                //     console.log('hi', newBuffer);
                //     console.log('bye', buffer);
                //     setBuffer(newBuffer);
                // });
            });
    }, [url, audioContext]);

    const makeSource = React.useCallback(
        buffer => {
            const src = audioContext.createBufferSource();
            src.connect(audioContext.destination);
            src.buffer = buffer;
            return src;
        },
        [audioContext]
    );

    // Construct source node and start playing on first time
    React.useEffect(() => {
        if (!buffer) return;

        // console.log('constructing buffer');

        const src = makeSource(buffer);

        setSource(src);
        setPlaying(false);
        setDuration(buffer.duration);
        setElapsed(0);
    }, [buffer, onPlaybackEnd, audioContext, makeSource]);

    // If we pause construct a new src ready to play.
    React.useEffect(() => {
        if (!buffer) return;
        if (elapsed === 0) return;

        console.log('reconstruct src');

        const src = makeSource(buffer);

        setSource(src);
    }, [buffer, audioContext, elapsed, makeSource]);

    const timeoutCallback = React.useCallback(
        time => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                onPlaybackEnd && onPlaybackEnd();
            }, time * 1000);
        },
        [onPlaybackEnd]
    );

    React.useState(() => {
        if (duration) {
            timeoutCallback(duration);
        }
    }, [duration]);

    // This hook is the one that starts/stops
    React.useEffect(() => {
        if (!source) return;
        if (paused && playing) {
            console.log('PAUSING AUDIO');
            const now = performance.now() / 1000;
            const last = startedPlayingAt.current;
            const timeSince = now - last;
            source.stop();
            setPlaying(false);
            setElapsed(elapsed => elapsed + timeSince);
            clearTimeout(timeoutRef.current);
        } else if (!paused && !playing && url) {
            const remaining = duration - elapsed;
            if (remaining > 0) {
                console.log('PLAYING AUDIO', remaining, 'left');
                timeoutCallback(remaining);
                source.start(0, elapsed);
                startedPlayingAt.current = performance.now() / 1000;
                setPlaying(true);
            }
        }
    }, [paused, duration, elapsed, timeoutCallback, source, playing, url]);
}
